import ArticleCardComponent, {
  ArticleCardProps,
} from "@/components/ArticleCard";
import { RelatedArticlesContainer } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const ArticleCard = ArticleCardComponent as any;

type RelatedArticlesProps = {
  articles?: ArticleCardProps[];
};

const RelatedArticles: React.FC<RelatedArticlesProps> = (props) => {
  const { articles } = props;
  return (
    <RelatedArticlesContainer>
      {articles &&
        articles.map((article, index) => (
          <ArticleCard key={`article-${index}`} {...article} />
        ))}
    </RelatedArticlesContainer>
  );
};

export default RelatedArticles;
